<script setup lang="ts">
import PanelGroup from '../PanelGroup.vue'
import { EDITOR_TEXTS_SAVED } from '../../composables/editorTexts'

import MerchantTextFormal from '@/views/loyaltySupports/components/MerchantTextFormal.vue'

const { t } = useI18n()
const onTextsSaved = inject(EDITOR_TEXTS_SAVED, () => {})
</script>

<template>
  <PanelGroup :title="t('pages.loyaltySupports.webapp.editor.voice.title')">
    <div class="flex flex-col gap-3">
      <div class="flex flex-col">
        <p class="text-sm font-medium">{{ t('pages.loyaltySupports.webapp.editor.voice.politeLabel') }}</p>
        <p class="text-muted-foreground text-xs">
          {{ t('pages.loyaltySupports.webapp.editor.voice.politeDescription') }}
        </p>
      </div>
      <MerchantTextFormal :load-on-mount="false" @saved="onTextsSaved" />
    </div>
  </PanelGroup>
</template>
